<template>
  <div class="c-upload-img">
    <div v-show="bykApi.smCom.fSmIsEmpty(value)">
      <el-upload
        action="https://up.95516.com/interface/gateway"
        list-type="picture"
        :auto-upload="false"
        ref="upload"
        :multiple="true"
        :show-file-list="false"
        accept="image/jpeg,image/png"
        :on-change="(e) => fUploadImgChange(e, type)"
      >
        <div
          class="x-w130 x-h80 x-bd-ra-4 x-flex x-row-center x-m-r-10"
          style="flex-direction: column; border: 2px solid #ccc; color: #ccc"
        >
          <i class="el-icon-circle-plus-outline x-font-30 x-m-t-5 x-m-b-5"></i>
          <span>上传图片</span>
        </div>
      </el-upload>
    </div>
    <div
      class="x-w130 x-h80 x-bd-ra-4 x-m-r-10 image x-rela"
      v-show="!bykApi.smCom.fSmIsEmpty(value)"
    >
      <el-image class="x-w130 x-h80" :src="value"></el-image>
      <div
        class="x-abso x-w130 x-h80 x-bd-ra-4 x-top-0 x-flex x-row-center"
        style="background-color: rgba(0, 0, 0, 0.7); cursor: pointer"
      >
        <i class="el-icon-delete c-f x-font-18" @click="fCancelImg(type)"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    fUploadImgChange(e, type) {
      this.$emit("UploadImgChange", { e, type });
    },
    fCancelImg(type) {
      this.$emit("CancelImg", type);
    },
  },
};
</script>

<style scoped>
.c-upload-img {
}
.c-upload-img .image {
  transition: all 5s !important;
}
.c-upload-img .image .x-abso {
  display: none;
}
.c-upload-img .image:hover > div {
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/components/uploadImg.vue